import React, { useState } from 'react';
import { Utils } from '../../tools/utils';
import Stepper from '../../components/stepper';
import Contact from '../../classes/contact';
import Vehicle from '../../classes/vehicle';
import Customer from '../../classes/customer';
import Contract from '../../classes/contract';
import Shipping from '../../classes/shipping';
import Installer from '../../classes/installer';
import Payment from '../../classes/payment';
import { useTranslation } from 'react-i18next';
import { Layout } from 'antd';
import { useStore } from 'store';
import SicuriProtettiServices from 'js/data/sicuri-protetti-services';

const utils = new Utils();

const SePAddContract = () => {
    const { t } = useTranslation();
    const userInfo = useStore((state) => state.user);
    const setLoading = useStore((state) => state.setLoading);

    const [contract, setContract] = useState(new Contract());

    const productSelected = (productId: number, product?: string, price?: string, professional?: boolean) => {
        //Make the previous selected card to unselected
        if (contract.package.productId !== -1) {
            document.getElementById('check-' + contract.package.productId)!.hidden = true;
            document.getElementById('card-' + contract.package.productId)!.style.backgroundColor = '#F7F9FB';
            document.getElementById('periods-div-' + contract.package.productId)!.hidden = true;
            if (document.getElementById('options-div-' + contract.package.productId) != null)
                document.getElementById('options-div-' + contract.package.productId)!.hidden = true;
            //Make the previous selected period unselected
            if (contract.package.periodId !== -1 && contract.package.productId !== productId) {
                resetPeriodState();
                setContract((prevContract) => ({ ...prevContract, package: { ...prevContract.package, periodId: -1, period: undefined } }));
            }
            if (contract.package.options.length !== 0 && contract.package.productId !== productId) {
                resetOptionsState();
                setContract((prevContract) => ({ ...prevContract, package: { ...prevContract.package, options: [] } }));
                // this.forceUpdate();
            }
        }
        //Make the card selected.
        document.getElementById('check-' + productId)!.hidden = false;
        document.getElementById('card-' + productId)!.style.backgroundColor = '#e6f7ff';
        document.getElementById('periods-div-' + productId)!.hidden = false;
        if (document.getElementById('options-div-' + productId) != null)
            document.getElementById('options-div-' + productId)!.hidden = false;
        let totalPrice: number = parseInt(t('sicuri&protetti.packages.' + productId + '.price'));
        contract.package.options.forEach((option) => {
            totalPrice += parseInt(t('sicuri&protetti.options.' + option + '.price'));
        });
        setContract((prevContract) => ({
            ...prevContract,
            package: {
                ...prevContract.package,
                productId: productId,
                product: product,
                price: price,
                professional: professional,
                totalPrice: totalPrice,
            },
        }));
    };

    const optionModified = (option: string, op: number) => {
        const arr: string[] = contract.package.options;
        const index = arr.indexOf(option);
        switch (op) {
            case 0: //add
                arr.push(option);
                utils.SetOptionSelected(
                    'button-option-' + contract.package.productId + '-' + option,
                    'check-' + contract.package.productId + '-' + option
                );
                break;
            case 1: //remove
                if (index !== -1) {
                    arr.splice(index, 1);
                    utils.SetOptionUnselected(
                        'button-option-' + contract.package.productId + '-' + option,
                        'check-' + contract.package.productId + '-' + option
                    );
                }
                break;
        }
        setContract((prevContract) => ({ ...prevContract, package: { ...prevContract.package, options: arr } }));
        // this.forceUpdate();
    };

    const periodSelected = (periodId: number, period: string, productId: number) => {
        if (contract.package.periodId !== -1) {
            resetPeriodState();
        }
        const periodEl = document.getElementById('tag-period-' + productId + '-' + periodId);
        const circle = periodEl!.querySelector('.anticon-check-circle');
        circle!.removeAttribute('hidden');
        periodEl!.classList.replace('ant-tag-default', 'ant-tag-green');
        periodEl!.classList.add('tag-selected');
        setContract((prevContract) => ({
            ...prevContract,
            package: {
                ...prevContract.package,
                configurationId: periodId.toString(),
                periodId: periodId,
                period: period,
            },
        }));
    };

    const vehicleInserted = (values: Vehicle) => {
        setContract((prevContract) => ({
            ...prevContract,
            vehicle: {
                ...prevContract.vehicle,
                brandId: values.brandId,
                brand: values.brand === undefined ? prevContract.vehicle.brand : values.brand,
                licensePlate: values.licensePlate.toUpperCase(),
                colorId: values.colorId,
                color: values.color === undefined ? prevContract.vehicle.color : values.color,
                model: values.model,
                outfitting: values.outfitting,
                registrationDate: values.registrationDate,
                value: 0,
            },
        }));
    };

    const customerInserted = async (values: Customer) => {
        setLoading(true);
        let residence: string[];
        if (values.isBusiness === 0) {
            residence = await SicuriProtettiServices.geocode(
                values.cityResidence === undefined ? contract.customer.cityResidence : values.cityResidence,
                values.postalCodeResidence,
                values.provinceResidenceId === undefined ? contract.customer.provinceResidenceId : values.provinceResidenceId,
                values.addressResidence,
                'IT',
                1
            );
        } else {
            residence = await SicuriProtettiServices.geocode(
                values.citySociety === undefined ? contract.customer.citySociety : values.citySociety,
                values.postalCodeSociety,
                values.provinceSocietyId === undefined ? contract.customer.provinceSocietyId : values.provinceSocietyId,
                values.addressSociety,
                'IT',
                1
            );
        }
        setContract((prevContract) => ({
            ...prevContract,
            customer: {
                ...prevContract.customer,
                typeId: values.typeId,
                type: values.type === undefined ? prevContract.customer.type : values.type,
                surname: values.surname,
                firstname: values.firstname,
                stateOfBirthId: values.stateOfBirthId,
                stateOfBirth: values.stateOfBirth === undefined ? prevContract.customer.stateOfBirth : values.stateOfBirth,
                cityOfBirthId: values.cityOfBirthId,
                cityOfBirth: values.cityOfBirth === undefined ? prevContract.customer.cityOfBirth : values.cityOfBirth,
                dateOfBirth: values.dateOfBirth,
                fiscalId: values.fiscalId,
                cityResidenceId: values.cityResidenceId,
                cityResidence: values.cityResidence === undefined ? prevContract.customer.cityResidence : values.cityResidence,
                provinceResidenceId:
                    values.provinceResidenceId === undefined ? prevContract.customer.provinceResidenceId : values.provinceResidenceId,
                postalCodeResidence: values.postalCodeResidence,
                addressResidence: values.addressResidence,
                citySocietyId: values.citySocietyId,
                citySociety: values.citySociety === undefined ? prevContract.customer.citySociety : values.citySociety,
                provinceSocietyId:
                    values.provinceSocietyId === undefined ? prevContract.customer.provinceSocietyId : values.provinceSocietyId,
                postalCodeSociety: values.postalCodeSociety,
                addressSociety: values.addressSociety,
                docTypeId: values.docTypeId,
                docType: values.docType === undefined ? prevContract.customer.docType : values.docType,
                docNumber: values.docNumber,
                releasedBy: values.releasedBy,
                releasedOn: values.releasedOn,
                isBusiness: values.isBusiness,
                vatNumber: values.vatNumber,
                businessName: values.businessName,
                pec: values.pec,
                sdi: values.sdi,
                tel1: values.tel1,
                tel2: values.tel2,
                email: values.email,
            },
            contact: {
                ...prevContract.contact,
                firstname:
                    prevContract.contact.firstname === '' && values.isBusiness === 0 ? values.firstname : prevContract.contact.firstname,
                surname: prevContract.contact.surname === '' && values.isBusiness === 0 ? values.surname : prevContract.contact.surname,
                tel1: prevContract.contact.tel1 === '' && values.isBusiness === 0 ? values.tel1 : prevContract.contact.tel1,
                tel2: prevContract.contact.tel2 === '' && values.isBusiness === 0 ? values.tel2 : prevContract.contact.tel2,
                email: prevContract.contact.email === '' && values.isBusiness === 0 ? values.email : prevContract.contact.email,
            },
            shipping: {
                ...prevContract.shipping,
                provinceId:
                    values.provinceResidenceId === undefined ? prevContract.customer.provinceResidenceId : values.provinceResidenceId,
                cityId: values.cityResidenceId,
                city: values.cityResidence === undefined ? prevContract.customer.cityResidence : values.cityResidence,
                postalCode: values.postalCodeResidence,
                address: prevContract.shipping.address === undefined ? values.addressResidence : prevContract.shipping.address,
            },
            installer: {
                ...prevContract.installer,
                residenceGeoCoord: residence,
            },
        }));

        setLoading(false);
    };

    const contactInserted = async (values: Contact) => {
        setLoading(true);
        setContract((prevContract) => ({
            ...prevContract,
            contact: {
                ...prevContract.contact,
                firstname: values.firstname,
                surname: values.surname,
                email: values.email,
                tel1: values.tel1,
                tel2: values.tel2,
            },
            shipping: {
                ...prevContract.shipping,
                referenceName:
                    prevContract.shipping.referenceName === undefined
                        ? values.firstname + ' ' + values.surname
                        : prevContract.shipping.referenceName,
            },
        }));
        setLoading(false);
    };

    const shippingAddressInserted = (values: Shipping) => {
        setContract((prevContract) => ({
            ...prevContract,
            shipping: {
                ...prevContract.shipping,
                cityId: values.cityId,
                city: values.city === undefined ? prevContract.shipping.city : values.city,
                provinceId: values.provinceId === undefined ? prevContract.shipping.provinceId : values.provinceId,
                postalCode: values.postalCode,
                address: values.address,
                referenceName: values.referenceName,
            },
        }));
    };

    const installerInserted = (installer: Installer) => {
        setContract((prevContract) => ({
            ...prevContract,
            installer: {
                ...prevContract.installer,
                installerId: installer.installerId,
                businessName: installer.businessName,
                address: installer.address,
                contacts: installer.contacts,
                geoCoord: installer.geoCoord,
            },
        }));
        // this.forceUpdate();
    };

    const paymentInserted = (payment: Payment) => {
        const circuit = contract.payment.circuit;
        const nation = contract.payment.nation;
        setContract((prevContract) => ({ ...prevContract, payment: payment }));

        if (contract.payment.circuit === undefined && contract.payment.paymentTypeId === 1) {
            setContract((prevContract) => ({
                ...prevContract,
                payment: {
                    ...prevContract.payment,
                    circuit: circuit,
                },
            }));
        }
        if (contract.payment.nation === undefined && contract.payment.paymentTypeId === 11) {
            setContract((prevContract) => ({
                ...prevContract,
                payment: {
                    ...prevContract.payment,
                    nation: nation,
                },
            }));
        }
    };

    const resetPeriodState = () => {
        const period = document.getElementById('tag-period-' + contract.package.productId + '-' + contract.package.periodId);
        const circle = period!.querySelector('.anticon-check-circle');
        circle!.setAttribute('hidden', String(true));
        period!.classList.replace('ant-tag-green', 'ant-tag-default');
        period!.classList.remove('tag-selected');
    };

    const resetOptionsState = () => {
        let i = 0;
        for (i; i < contract.package.options.length; i++) {
            utils.SetOptionUnselected(
                'button-option-' + contract.package.productId + '-' + contract.package.options[i],
                'check-' + contract.package.productId + '-' + contract.package.options[i]
            );
        }
    };

    return (
        <Layout className="site-layout-background home-container center">
            <Stepper
                data={contract}
                userInfo={userInfo}
                productFun={productSelected}
                periodFun={periodSelected}
                optionsFun={optionModified}
                vehicleFun={vehicleInserted}
                customerFun={customerInserted}
                contactFun={contactInserted}
                shippingFun={shippingAddressInserted}
                installerFun={installerInserted}
                paymentFun={paymentInserted}
            />
        </Layout>
    );
};

export default SePAddContract;
